import lazySizes from 'lazysizes';

lazySizes.cfg.lazyClass = 'phxsg-lazyload';
lazySizes.cfg.loadedClass = 'phxsg-lazyloaded';
